// Linien-Icons im Stil von kalakutok.com: Graphit-Kontur, in jedem Icon genau EIN Detail in
// Signal-Orange. Ersetzen die farbigen Abzeichen-Bilder (img/experience|plant|certification.webp)
// und die Emoji der Kategorien.

const ORANGE = 'var(--signal)';

function Rahmen({ groesse = 18, children, titel }) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="square"
      role={titel ? 'img' : undefined}
      aria-label={titel}
      aria-hidden={titel ? undefined : true}
    >
      {children}
    </svg>
  );
}

// Praktische Erfahrung: Schraubenschluessel, Orange = Maulöffnung
export const ErfahrungIcon = (props) => (
  <Rahmen {...props}>
    <path d="M14.5 9.5 4 20" />
    <path d="M14 4.5a5 5 0 0 0 5.5 5.5" />
    <path d="M14 4.5a5 5 0 1 1 5.5 5.5" stroke={ORANGE} />
  </Rahmen>
);

// Allgemeines Wissen: aufgeschlagenes Buch, Orange = Lesezeichen
export const WissenIcon = (props) => (
  <Rahmen {...props}>
    <path d="M3 5h6a3 3 0 0 1 3 3v12a2 2 0 0 0-2-2H3z" />
    <path d="M21 5h-6a3 3 0 0 0-3 3v12a2 2 0 0 1 2-2h7z" />
    <path d="M16.5 5v5l1.5-1.2 1.5 1.2V5" stroke={ORANGE} />
  </Rahmen>
);

// Zertifikat: Urkunde, Orange = Siegel
export const ZertifikatIcon = (props) => (
  <Rahmen {...props}>
    <path d="M4 4h16v11H13" />
    <path d="M4 4v11h3" />
    <path d="M8 8h8" />
    <circle cx="10" cy="15" r="2.5" stroke={ORANGE} />
    <path d="M8.5 17.2 8 21l2-1 2 1-.5-3.8" />
  </Rahmen>
);

// Webentwicklung: Browserfenster mit Code-Klammern, Orange = Schraegstrich
export const EntwicklungIcon = (props) => (
  <Rahmen {...props}>
    <path d="M3 4h18v16H3z" />
    <path d="M3 8h18" />
    <path d="m9 12-2.5 2.5L9 17M15 12l2.5 2.5L15 17" />
    <path d="m13 11.5-2 6" stroke={ORANGE} />
  </Rahmen>
);

// Systemadministration: Server-Rack, Orange = Statuslampe
export const AdministrationIcon = (props) => (
  <Rahmen {...props}>
    <path d="M4 3h16v8H4zM4 13h16v8H4z" />
    <path d="M8 7h5M8 17h5" />
    <path d="M16.5 7h.5" stroke={ORANGE} strokeWidth="2" />
    <path d="M16.5 17h.5" strokeWidth="2" />
  </Rahmen>
);
